<template>
  <div class="col-12">
    <div class="row text-center m-5" v-if="!showPasswordForm">
      <h3 class="ui inverted purple text"><strong> Customer Details</strong></h3>
      <p class="text-muted fw-light mr-4 ml-4">Change the details if the populated information is incorrect.</p>
    </div>
    <div class="row d-flex justify-content-center align-items-center mt-5">
      <div class="col-11 col-lg-10">
        <form class="ui form" @submit.prevent="submitForm()">

          <div class="card-body" v-if="!showPasswordForm">
            <h4 class="ui dividing header">Personal Information</h4>
            <div class="field">
              <div class="fields">
                <div class="eight wide field">
                  <label>Mobile Number</label>
                  <input type="number" name="mobileNumber" v-model="customer.mobileNumber" disabled
                    placeholder="Mobile Number">
                  <small v-if="errors.phone" class="text-danger">{{ errors.phone }}</small>
                </div>

                <div class="eight wide field">
                  <label>Email</label>
                  <input type="text" name="email" v-model="customer.email" placeholder="Email">
                  <small v-if="!isEmailValid" class="text-danger mt-1">
                    The Email is required
                  </small>
                </div>

              </div>
            </div>
            <div class="field">
              <label>Full Name</label>
              <div class="two fields">

                <div class="field">
                  <input type="text" name="firstName" v-model="customer.firstName" placeholder="First Name">
                  <small v-if="!isFirstNameValid" class="text-danger mt-1">
                    The First Name is required
                  </small>
                </div>
                <div class="field">
                  <input type="text" name="lastName" v-model="customer.lastName" placeholder="Last Name">
                  <small v-if="!isLastNameValid" class="text-danger mt-1">
                    The Last Name is required
                  </small>
                </div>
              </div>
            </div>

            <div class="field">
              <div class="fields">
                <div class="eight wide field">
                  <label>National ID Number</label>
                  <input type="text" name="identityDocNo" v-model="customer.identityDocNo"
                    placeholder="National ID Number">
                  <small v-if="!isIdNumberValid" class="text-danger mt-1">
                    The National ID Number is required
                  </small>
                </div>
              </div>
            </div>
          </div>

          <div class="card-body" v-if="showPasswordForm">
            <h4 class="ui dividing header">Set Password</h4>
            <div class="field">
              <label>Password</label>
              <input type="password" v-model="customer.password" placeholder="Password">
              <small v-if="!isPasswordValid" class="text-danger mt-1">
                Password must be at least 4 characters long
              </small>
            </div>
            <div class="field">
              <label>Confirm Password</label>
              <input type="password" v-model="customer.confirmPassword" placeholder="Confirm Password">
              <small v-if="!isConfirmPasswordValid" class="text-danger mt-1">
                Passwords do not match
              </small>
            </div>
          </div>

          <div class="card-footer">
            <button class="ui button purple fluid mt-4" v-if="!showPasswordForm"
              :disabled="!isFormValid && !showPasswordForm" type="submit">
              Next
            </button>
            <button class="ui button grey fluid mt-4 mb-4" v-if="!showPasswordForm" @click="back()">Back</button>
            <button class="ui button purple fluid mt-4" :disabled="!isPasswordFormValid" v-if="showPasswordForm"
              @click="submitPasswordForm">
              Submit Password
            </button>
          </div>

        </form>
      </div>
    </div>
  </div>
</template>

<script>
import baseMethods from "@/utils/baseMethods";
import { URLS } from "@/utils/constants";
import { useAuthStore } from '@/stores/auth';
import { useCustomerStore } from '@/stores/customer';

export default {
  name: "Register",
  setup() {
    const authStore = useAuthStore();
    const customerStore = useCustomerStore();
    return { authStore, customerStore };
  },
  data() {
    return {
      customer: {
        mobileNumber: '',
        phone: '',
        title: "",
        firstName: "",
        lastName: "",
        identityDocNo: "",
        email: "",
        gotCustomerData: false,
        requestType: "FETCH_CUSTOMER_DETAILS",
        dateOfBirth: null,
        country: "",
        password: "",
        pin: "",
        confirmPassword: "",
        channel: "MOBILE",
        idNoType: "national-id",
        idNo: '',
        uuid: '',
      },
      accountCreationRequest: {
        mobileNumber: '',
        requestType: "FETCH_CUSTOMER_DETAILS",
      },
      model: {
        gender: [{ name: "MALE" }, { name: "FEMALE" }],
        title: [
          { name: "MR" },
          { name: "MRS" },
          { name: "MISS" },
        ],
        maritalStatus: [{ name: "Single" }, { name: "Married" }, { name: "Widowed" }, { name: "Divorced" }, { name: "Separated" }]
      },
      showPasswordForm: false,
      errors: {},
      operations: 0,
    };
  },
  computed: {
    phone() { return this.authStore.phone; },
    user() { return this.authStore.user; },
    uuid() { return this.authStore.uuid; },
    storedIdentityDocNo() { return this.customerStore.identityDocNo; },
    isFirstNameValid() {
      return !!this.customer.firstName;
    },
    isLastNameValid() {
      return !!this.customer.lastName;
    },
    isIdNumberValid() {
      return !!this.customer.identityDocNo && /([0-9]{8,9}[a-z,A-Z][0-9]{2}$)/g.test(this.customer.identityDocNo);
    },
    isEmailValid() {
      return !!this.customer.email && /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(this.customer.email);
    },
    isPasswordValid() {
      return this.customer.password.length >= 4;
    },
    isConfirmPasswordValid() {
      return this.customer.password === this.customer.confirmPassword;
    },
    isFormValid() {
      return (
        this.isFirstNameValid &&
        this.isLastNameValid &&
        this.isIdNumberValid &&
        this.isEmailValid
      );
    },
    isPasswordFormValid() {
      return this.isPasswordValid && this.isConfirmPasswordValid;
    },
  },
  created() {
    // Initialize data from Pinia store
    this.customer.mobileNumber = this.phone || this.user?.phone || this.user?.fphone;
    this.customer.phone = this.phone || this.user?.phone || this.user?.fphone;
    this.customer.idNo = this.storedIdentityDocNo;
    this.customer.uuid = this.uuid;
    this.accountCreationRequest.mobileNumber = this.phone || this.user?.phone || this.user?.fphone;

    // Pre-populate fields from user data if available
    if (this.user) {
      if (this.user.email) {
        this.customer.email = this.user.email;
      }
      if (this.user.name) {
        this.customer.firstName = this.user.name;
      }
      if (this.user.last_name) {
        this.customer.lastName = this.user.last_name;
      }
      if (this.user.national_id) {
        this.customer.identityDocNo = this.user.national_id;
      }
    }
  },
  mounted() {
    this.getCustomerDetails();
  },
  methods: {
    back() {
      this.$router.push("/account-opening/diaspora-currency-type");
    },
    submitForm() {
      if (this.isFormValid) {
        // Save customer details to Vuex store
        this.setCustomerDetails({
          firstName: this.customer.firstName,
          lastName: this.customer.lastName,
          identityDocNo: this.customer.identityDocNo,
          email: this.customer.email,
        });
        this.showPasswordForm = true;
      } else {
        console.log("Error Submitting");
      }
    },
    submitPasswordForm() {
      if (this.isPasswordFormValid) {
        // SECURITY: Never store passwords in localStorage or Vuex
        // Password is only used for this request and discarded

        const registrationPayload = {
          requestType: 'REGISTRATION',
          name: this.customer.firstName,
          lastName: this.customer.lastName,
          idNo: this.customer.identityDocNo,
          idNoType: this.customer.idNoType,
          pin: this.customer.password,
          phone: this.customer.phone,
          email: this.customer.email,
          channel: this.customer.channel,
          uuid: this.customer.uuid,
        };

        this.post_auth_no_auth('/authentication', registrationPayload, "Successful").then((res) => {
          if (res && res.success) {
            this.login({
              accessToken: res.body.accessToken,
              userId: res.body.userId,
            });
            this.$router.push("/account-opening/diaspora-signature");
          }
        });

      }
    },
    getCustomerDetails() {
      this.postNoAuthAndNoBaseUrl(
        URLS.processAccount,
        this.accountCreationRequest,
        "Got Customer Data",
        null,
        true
      ).then((res) => {
        if (!res) return;
        if (res.errors) return (this.errors = res.errors);
        if (res.body.status === "COMPLETE") {
          this.customer.title = res.body.title;
          this.customer.firstName = res.body.firstName;
          this.customer.lastName = res.body.lastName;
          this.customer.identityDocNo = res.body.idNumber;

          this.customer.gotCustomerData = true;
          this.customer.requestType = "PRE_PROCESS_DIASPORA_ACCOUNT";
          this.customer.header = "Please Confirm Your Customer Details";
          // Populate email from API response if available
          if (res.body.email) {
            this.customer.email = res.body.email;
          }
        } else {
          //   this.$router.push("/account-opening/isave-failed");
        }
      });
    },
    login(data) { this.authStore.login(data); },
    setCustomerDetails(details) { this.customerStore.setCustomerDetails(details); },
    ...baseMethods,
  },
};
</script>
